import { MultiSelectInputProps, Option } from './MultiSelectInput.types';
import { Checkbox, FormControl, InputLabel, ListItemText, MenuItem, OutlinedInput, Select } from '@mui/material';
import { Grid } from '@mui/material';
import { SelectChangeEvent } from '@mui/material';

const defaultRenderOption = (option: Option, selectedOptions: (number | string)[]) => (
  <MenuItem key={option.id} value={option.id} disabled={option.disabled}>
    <Checkbox checked={selectedOptions.includes(option.id)} />
    <ListItemText primary={option.title} />
  </MenuItem>
);

const defaultRenderValue = (id: number | string, options: Option[]) => {
  const option = options.find((option) => option.id === id);
  return option ? option.title : '';
};

export const MultiSelectInput = ({
  title,
  options = [],
  selectedOptions = [],
  renderOption = defaultRenderOption,
  renderValue = defaultRenderValue,
  onChange,
  sx,
  isError = false,
}: MultiSelectInputProps) => {
  const handleChange = (event: SelectChangeEvent<(number | string)[]>) => {
    onChange(event.target.value as (number | string)[]);
  };

  return (
    <Grid item>
      <FormControl error={isError} sx={{ ...sx }}>
        <InputLabel
          id="multi-select-label"
          sx={{
            '&.MuiInputLabel-outlined:not(.MuiInputLabel-shrink)': {
              transform: (theme) => `translate(${theme.spacing(2)}, ${theme.spacing(1)}) `,
            },
          }}
        >
          {title}
        </InputLabel>
        <Select
          labelId="multi-select-label"
          id="multi-select"
          multiple
          size="small"
          value={selectedOptions}
          onChange={handleChange}
          input={<OutlinedInput label={title} />}
          renderValue={(selected) => selected.map((id) => renderValue(id, options)).join(', ')}
          MenuProps={{
            PaperProps: {
              style: {
                minWidth: 250,
              },
            },
          }}
        >
          {options.map((option) => renderOption(option, selectedOptions))}
        </Select>
      </FormControl>
    </Grid>
  );
};
